import { ref } from "vue";

// The id of the conversation currently open on the messaging screen, or null when there isn't one.
// Other parts of the app (like the notification bell) use this to leave out things the user can already see.
export const activeConversationId = ref(null);
